import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NoticeEntry} from "../../pages/client/alarms/notices/notice.entry";

@Pipe({name: 'tunnelReservationNotice'})
export class TunnelReservationNoticePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: NoticeEntry): string {
    if (value != null) {
      let additionalInfos = value.additionalInfo.split(' / ');
      let tunnelName = additionalInfos[0] != null
        ? this.translate.instant('messages.notices.tunnelName.' + additionalInfos[0])
        : '';
      let arrivingAt = additionalInfos[1]
      return `${tunnelName}` + ' ' + `${arrivingAt}`;
    }
    return '';
  }
}
